import { IconWrapper } from '../runtime';
export default IconWrapper('add-up', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M8 1.75V6.75M10.5 4.25H5.5M3.5 14.25C2.67157 14.25 2 13.5784 2 12.75L2 11.25C2 10.4216 2.67157 9.75 3.5 9.75H12.5C13.3284 9.75 14 10.4216 14 11.25V12.75C14 13.5784 13.3284 14.25 12.5 14.25H3.5Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});